export default __webpack_public_path__ + "static/media/loading-animate-allpos.bf6bf408.svg";